import IconButton from '@material-ui/core/IconButton'
import React from 'react'
import { ColoredLogoSvg, IconMenuControl } from '../../../svg'
import useStyles from '../styles'
import UserMenu from '../UserMenu'

const AppHeader = ({ setDrawerOpen, openDrawer, setDrawerClose, isSmallScreen }) => {
  const styles = useStyles()

  return (
    <div className={styles.appHeader}>
      {isSmallScreen && (
        <IconButton
          disableFocusRipple
          disableRipple
          className={styles.btnToggle}
          edge="start"
          color="inherit"
          onClick={openDrawer ? setDrawerClose : setDrawerOpen}
        >
          <IconMenuControl rotate={openDrawer} />
        </IconButton>
      )}

      {isSmallScreen && (
        <div className={styles.mobileAppLogo}>
          <ColoredLogoSvg />
        </div>
      )}

      <div className={styles.searchDiv} />

      <div className={styles.rightMenu}>
        <UserMenu />
      </div>
    </div>
  )
}

export default AppHeader